var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _circle3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _g, _rect33, _rect34, _path13, _path14, _path15, _path16, _path17, _rect35, _rect36, _rect37, _rect38, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPapers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 173,
    viewBox: "0 0 176 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.8868,
    y: 65.913,
    width: 20,
    height: 8,
    transform: "rotate(114.14 38.8868 65.913)",
    fill: "#66CC84"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68.8046,
    y: 151,
    width: 20,
    height: 8,
    transform: "rotate(77.3096 68.8046 151)",
    fill: "#A477FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57.584,
    y: 7,
    width: 20,
    height: 8,
    transform: "rotate(26.6159 57.584 7)",
    fill: "#FFBF39"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 67.9774,
    width: 20,
    height: 8,
    transform: "rotate(-87.2776 71 67.9774)",
    fill: "#F46670"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.16 129.108C156.124 128.507 156.602 128 157.204 128C157.806 128 158.283 128.507 158.247 129.108L157.204 146.5L156.16 129.108Z",
    fill: "#FFBF39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.16 163.892C156.124 164.493 156.602 165 157.204 165C157.806 165 158.283 164.493 158.247 163.892L157.204 146.5L156.16 163.892Z",
    fill: "#FFBF39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.455 131.886C147.123 131.384 147.283 130.706 147.805 130.405C148.326 130.104 148.993 130.304 149.263 130.843L157.055 146.426L147.455 131.886Z",
    fill: "#FFBF39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.847 162.01C165.116 162.549 165.783 162.749 166.305 162.448C166.826 162.147 166.986 161.469 166.655 160.967L157.055 146.426L164.847 162.01Z",
    fill: "#FFBF39"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.455 160.967C147.123 161.469 147.283 162.147 147.805 162.448C148.326 162.749 148.993 162.549 149.263 162.01L157.055 146.426L147.455 160.967Z",
    fill: "#FFBF39"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.847 130.843C165.116 130.304 165.783 130.104 166.305 130.405C166.826 130.706 166.986 131.384 166.655 131.886L157.055 146.426L164.847 130.843Z",
    fill: "#FFBF39"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.916 138.929C141.378 138.66 141.178 137.993 141.479 137.471C141.78 136.95 142.457 136.79 142.96 137.122L157.5 146.721L141.916 138.929Z",
    fill: "#FFBF39"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.04 156.321C172.543 156.653 173.221 156.493 173.522 155.971C173.823 155.45 173.622 154.783 173.084 154.514L157.5 146.721L172.04 156.321Z",
    fill: "#FFBF39"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.916 153.924C141.378 154.193 141.178 154.86 141.479 155.382C141.78 155.903 142.457 156.063 142.96 155.731L157.5 146.132L141.916 153.924Z",
    fill: "#FFBF39"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.04 136.532C172.543 136.2 173.221 136.36 173.522 136.882C173.823 137.403 173.622 138.07 173.084 138.339L157.5 146.132L172.04 136.532Z",
    fill: "#FFBF39"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.108 145.088C139.507 145.052 139 145.53 139 146.132C139 146.734 139.507 147.211 140.108 147.175L157.5 146.132L140.108 145.088Z",
    fill: "#FFBF39"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M174.892 145.088C175.493 145.052 176 145.53 176 146.132C176 146.734 175.493 147.211 174.892 147.175L157.5 146.132L174.892 145.088Z",
    fill: "#FFBF39"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 125.5,
    r: 12.0331,
    stroke: "#FFBF39",
    strokeWidth: 1.13378,
    strokeMiterlimit: 3.8637,
    strokeLinejoin: "round",
    strokeDasharray: "1.12 1.12"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5002,
    cy: 125.5,
    r: 16.5331,
    stroke: "#FFBF39",
    strokeWidth: 1.13378,
    strokeMiterlimit: 3.8637,
    strokeLinejoin: "round",
    strokeDasharray: "2.25 2.25"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 125.5,
    r: 21.9331,
    stroke: "#FFBF39",
    strokeWidth: 1.13378,
    strokeMiterlimit: 3.8637,
    strokeLinejoin: "round",
    strokeDasharray: "3.37 3.37"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 46.037,
    width: 3.7037,
    height: 0.925926,
    fill: "#FFBF39"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0927,
    y: 46.0371,
    width: 3.7037,
    height: 0.925926,
    fill: "#FFBF39"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 37.2037,
    y: 46.0371,
    width: 3.7037,
    height: 0.925926,
    fill: "#FFBF39"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2963,
    y: 46.0371,
    width: 3.7037,
    height: 0.925926,
    fill: "#FFBF39"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6482,
    y: 46.037,
    width: 3.7037,
    height: 0.925926,
    fill: "#FFBF39"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 33.0372,
    y: 59,
    width: 3.7037,
    height: 0.925926,
    transform: "rotate(-90 33.0372 59)",
    fill: "#FFBF39"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 33.037,
    y: 53.9075,
    width: 3.70371,
    height: 0.925926,
    transform: "rotate(-90 33.037 53.9075)",
    fill: "#FFBF39"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 33.037,
    y: 42.7964,
    width: 3.70371,
    height: 0.925926,
    transform: "rotate(-90 33.037 42.7964)",
    fill: "#FFBF39"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 33.0371,
    y: 37.7037,
    width: 3.70371,
    height: 0.925926,
    transform: "rotate(-90 33.0371 37.7037)",
    fill: "#FFBF39"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 33.037,
    y: 48.3519,
    width: 3.70371,
    height: 0.925926,
    transform: "rotate(-90 33.037 48.3519)",
    fill: "#FFBF39"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9884,
    y: 37.3339,
    width: 3.7037,
    height: 0.925926,
    transform: "rotate(45 24.9884 37.3339)",
    fill: "#FFBF39"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5894,
    y: 40.9349,
    width: 3.7037,
    height: 0.925926,
    transform: "rotate(45 28.5894 40.9349)",
    fill: "#FFBF39"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 36.4462,
    y: 48.7916,
    width: 3.7037,
    height: 0.925926,
    transform: "rotate(45 36.4462 48.7916)",
    fill: "#FFBF39"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0471,
    y: 52.3927,
    width: 3.7037,
    height: 0.925926,
    transform: "rotate(45 40.0471 52.3927)",
    fill: "#FFBF39"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5179,
    y: 44.8632,
    width: 3.7037,
    height: 0.925926,
    transform: "rotate(45 32.5179 44.8632)",
    fill: "#FFBF39"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3337,
    y: 55.0116,
    width: 3.7037,
    height: 0.925926,
    transform: "rotate(-45 24.3337 55.0116)",
    fill: "#FFBF39"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9347,
    y: 51.4106,
    width: 3.7037,
    height: 0.925926,
    transform: "rotate(-45 27.9347 51.4106)",
    fill: "#FFBF39"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7915,
    y: 43.554,
    width: 3.7037,
    height: 0.925926,
    transform: "rotate(-45 35.7915 43.554)",
    fill: "#FFBF39"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 3.7037,
    height: 0.925926,
    transform: "matrix(0.707106 -0.707107 0.707106 0.707107 39.3925 39.9528)",
    fill: "#FFBF39"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 31.8629,
    y: 47.4821,
    width: 3.7037,
    height: 0.925926,
    transform: "rotate(-45 31.8629 47.4821)",
    fill: "#FFBF39"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5927,
    y: 49.2219,
    width: 0.925926,
    height: 5.55555,
    transform: "rotate(-70 38.5927 49.2219)",
    fill: "#FFBF39"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925926,
    height: 5.55555,
    transform: "matrix(0.34202 0.939693 0.939693 -0.34202 38.5927 43.7704)",
    fill: "#FFBF39"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3518,
    y: 51.9093,
    width: 0.925926,
    height: 5.55556,
    transform: "rotate(-20 35.3518 51.9093)",
    fill: "#FFBF39"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925926,
    height: 5.55556,
    transform: "matrix(0.939693 0.34202 0.34202 -0.939693 35.3518 41.0723)",
    fill: "#FFBF39"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925926,
    height: 5.55555,
    transform: "matrix(-0.34202 -0.939693 -0.939693 0.34202 28.389 49.222)",
    fill: "#FFBF39"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 28.389,
    y: 43.7705,
    width: 0.925926,
    height: 5.55555,
    transform: "rotate(110 28.389 43.7705)",
    fill: "#FFBF39"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 0.925926,
    height: 5.55555,
    transform: "matrix(-0.939693 -0.34202 -0.34202 0.939693 31.6299 51.9093)",
    fill: "#FFBF39"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6299,
    y: 41.0724,
    width: 0.925926,
    height: 5.55556,
    transform: "rotate(160 31.6299 41.0724)",
    fill: "#FFBF39"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_932_162394)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 54,
    r: 20,
    fill: "white"
  }))), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 122.632,
    y: 39,
    width: 4.73684,
    height: 30,
    rx: 2.36842,
    fill: "#FFBF39"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 56.3684,
    width: 4.73684,
    height: 30,
    rx: 2.36842,
    transform: "rotate(-90 110 56.3684)",
    fill: "#FFBF39"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4421 136.305L101.046 142.083C102.398 142.216 103.601 141.226 103.73 139.874L109.258 82.0162L99.7403 71.3445L90.6841 61.4076L50.2461 57.2519C48.8939 57.113 47.6864 58.0996 47.5531 59.4523L40.2408 133.622C40.1078 134.971 41.0934 136.172 42.4421 136.305Z",
    fill: "#648CFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7219 61.2426L109.326 81.9251L92.4371 80.2601C90.4734 80.0665 89.0385 78.3176 89.2321 76.3539L90.7219 61.2426Z",
    fill: "#2538BF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1581 156.437L133.576 149.006C134.923 148.834 135.875 147.601 135.699 146.254L128.19 88.6197L116.533 80.3382L105.49 72.6701L65.1432 77.6333C63.7941 77.7993 62.8369 79.0303 63.0084 80.3787L72.414 154.312C72.585 155.657 73.8136 156.608 75.1581 156.437Z",
    fill: "#2538BF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.704 154.597L131.121 147.165C132.469 146.994 133.421 145.761 133.245 144.414L125.736 86.7794L114.079 78.4978L103.036 70.8297L62.6891 75.793C61.34 75.959 60.3828 77.1899 60.5544 78.5383L69.9599 152.472C70.131 153.817 71.3595 154.768 72.704 154.597Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.036 70.6605L125.783 86.6754L108.947 88.8171C106.99 89.0661 105.201 87.6812 104.952 85.7237L103.036 70.6605Z",
    fill: "#A8CCF8"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3016,
    y: 93.6167,
    width: 26.3804,
    height: 3.68098,
    rx: 1.84049,
    transform: "rotate(-7.25 69.3016 93.6167)",
    fill: "#A8CCF8"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 71.0823,
    y: 107.614,
    width: 49.6933,
    height: 3.68098,
    rx: 1.84049,
    transform: "rotate(-7.25 71.0823 107.614)",
    fill: "#A8CCF8"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 72.8631,
    y: 121.612,
    width: 49.6933,
    height: 3.68098,
    rx: 1.84049,
    transform: "rotate(-7.25 72.8631 121.612)",
    fill: "#A8CCF8"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 74.6438,
    y: 135.61,
    width: 39.8773,
    height: 3.68098,
    rx: 1.84049,
    transform: "rotate(-7.25 74.6438 135.61)",
    fill: "#A8CCF8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_932_162394",
    x: 103,
    y: 34,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_932_162394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_932_162394",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapers);
export default __webpack_public_path__ + "static/media/papers.57ef4336108d706218e43b5fe36ca67d.svg";
export { ForwardRef as ReactComponent };